// @ts-check
import React, { Component } from "react"
import { Button } from "ui"
import { selectPageAction } from "../../attributes/items/actions/pageActions"
import AvailableActions from "../../actions/AvailableActions"
import { text } from "../../attributes/items/primitives"

// import { text, select, boolean } from "../../_Editor/Attributes/_Composed"

// import TextAttribute from "../../_Editor/Attributes/TextAttribute"
// import DictListAttribute from "../../_Editor/Attributes/DictListAttribute"
// import Attribute from "../../_Editor/Attributes/ElementAttribute"

/**
 * @augments {Component<BlockTypeProps, {datetime?: Date}>}
 */
export default class ButtonBlockType extends Component {
    render() {
        const Wrapper = this.props.Wrapper

        return (
            <AvailableActions>
                {actions => {
                    return (
                        <Wrapper {...this.props}>
                            {({ attrs, computedStyle, evaluateFormulas, runOnClick }) => (
                                <Button
                                    type={attrs.type}
                                    size="small"
                                    disabled={!attrs.action || attrs.disabled}
                                    round={attrs.round}
                                    icon={attrs.icon && evaluateFormulas(attrs.icon)}
                                    onClick={() => runOnClick(actions)}
                                    style={{ ...computedStyle, width: "100%", height: "100%" }}
                                >
                                    {evaluateFormulas(attrs.buttonTitle)}
                                </Button>
                            )}
                        </Wrapper>
                    )
                }}
            </AvailableActions>
        )
    }
}

ButtonBlockType.attributes = [text({ field: "buttonTitle", label: "Title" })]

ButtonBlockType.behaviours = {
    onClick: true,
}



// WEBPACK FOOTER //
// ./src/features/editor/blockTypes/form/ButtonBlock_v2.js